import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  dialog: {
    '& .MuiDialog-paper': {
      ...theme.scrollbarStylesSoft
    }
  },
  multFieldLine: {
    display: 'flex',
    alignItems: 'flex-end',
    '& > *:not(:last-child)': {
      marginRight: theme.spacing(1)
    }
  },

  btnWrapper: {
    position: 'relative'
  },

  gridContainerAvatar: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  avatarContainer: {
    textAlign: 'center',
    position: 'relative',
    '& label': {
      cursor: 'pointer',
      width: '40px',
      height: '40px',

      backgroundColor: theme.palette.green_200.main,
      color: theme.palette.white_100.main,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      position: 'absolute',
      bottom: '-6px',
      right: '7px',
      zIndex: 1
    },
    '& label:hover': {
      backgroundColor: theme.palette.blue_300.main,
      transition: 'all 0.2s ease-in-out'
    },
    '& input': {
      display: 'none'
    }
  },
  avatarClickable: {
    cursor: 'pointer'
  },
  avatar: {
    margin: 'auto'
  },
  dialogTitle: {
    color: theme.palette.blue_300.main
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',

    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2),
    borderTop: 'none !important',
    overflowX: 'hidden'
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px'
  },
  sectionTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    color: theme.palette.blue_300.main,
    '& h6': {}
  },

  infoBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& > span': {
      fontSize: '.75rem',
      fontWeight: 'bold',
      textAlign: 'center',
      color: theme.palette.blue_300.main
    }
  },

  dialogWarning: {
    '& .MuiDialog-paper': {
      width: '400px',
      maxWidth: '400px',
      borderRadius: '8px'
    }
  },
  warningContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    '& svg': {
      color: theme.palette.red_100.main
    }
  },
  dialogWarningTitle: {
    '& .MuiDialogTitle-root': {
      padding: '0 !important'
    }
  },
  warningTitle: {
    fontSize: '1.6rem',
    fontWeight: '600',
    color: theme.palette.red_100.main
  },
  warningDescription: {
    fontWeight: '400',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },

  checkbox: {
    color: theme.palette.blue_300.main,
    backgroundColor: 'transparent',
    '&.Mui-checked': {
      color: theme.palette.blue_300.main,
      '&:hover': {
        backgroundColor: 'transparent'
      }
    }
  },

  inputSwitchWrapper: {
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
    gap: '8px'
  },

  botListItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  botIcon: {
    color: theme.palette.blue_300.main
  },
  botName: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  showPassword: {
    backgroundColor: 'transparent',
    padding: 0,
    '& svg': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    },
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  inputSwitchGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },

  statusContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  scheduleHeader: {
    marginBottom: theme.spacing(1)
  },
  scheduleRow: {
    marginBottom: theme.spacing(1)
  },
  statusBadge: {
    width: 12,
    height: 12,
    borderRadius: '50%',
    display: 'inline-block'
  },
  statusInfo: {
    fontSize: '0.875rem',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },

  badgeAtivo: {
    backgroundColor: theme.palette.green_200.main,
    boxShadow: `0 0 0 0 ${theme.palette.green_200.main}66`,
    animation: '$pulseSuccess 2s infinite ease-in-out'
  },

  badgeInativo: {
    backgroundColor: theme.palette.red_100.main,
    boxShadow: `0 0 0 0 ${theme.palette.red_100.main}66`,
    animation: '$pulseError 2s infinite ease-in-out'
  },

  '@keyframes pulseSuccess': {
    '0%': {
      boxShadow: `0 0 0 0 ${theme.palette.green_200.main}a1`
    },
    '70%': {
      boxShadow: `0 0 0 10px ${theme.palette.green_200.main}00`
    },
    '100%': {
      boxShadow: `0 0 0 0 ${theme.palette.green_200.main}00`
    }
  },

  '@keyframes pulseError': {
    '0%': {
      boxShadow: `0 0 0 0 ${theme.palette.red_100.main}a1`
    },
    '70%': {
      boxShadow: `0 0 0 10px ${theme.palette.red_100.main}00`
    },
    '100%': {
      boxShadow: `0 0 0 0 ${theme.palette.red_100.main}00`
    }
  },

  formControl: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '& .MuiOutlinedInput-root': {
      height: '26px',
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gray_50.main,
      borderRadius: '8px',
      padding: '0px 4px !important' // Ajuste para os chips não colarem nas bordas
    },
    '& label': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    }
  },
  listbox: {
    maxHeight: '200px',
    overflowY: 'auto',
    ...theme.scrollbarStyles,
    '& .MuiAutocomplete-option': {
      padding: '0px 8px',
      margin: '0',
      color: theme.palette.type === 'dark'
        ? theme.palette.dark_50.main + '!important'
        : theme.palette.gray_400.main + '!important',
      '&:not(.Mui-selected)': {
        color: theme.palette.type === 'dark'
          ? theme.palette.dark_50.main + '!important'
          : theme.palette.gray_400.main + '!important'
      }
    }
  },
  chip: {
    borderRadius: '4px',
    textTransform: 'uppercase',
    margin: '2px !important'
  }
}))
